export default __webpack_public_path__ + "static/media/MP0031.5eb33920.jpg";